import { createSlice } from '@reduxjs/toolkit';
import { currentYear } from '../../utils/tools';

export const uiSlice = createSlice({
    name: 'ui',
    initialState: {
        selectedYear: currentYear(),
        selectedQuarter: 0,
    },
    reducers: {
        setYear: (state, action) => {
            state.selectedYear = action.payload
        },
        setQuarter: (state, action) => {
            state.selectedQuarter = action.payload
        }
    }
});

export const { setYear, setQuarter } = uiSlice.actions;
export default uiSlice.reducer;
